import React from 'react'
import TeamWork from '../../../images/Teamwork.png'

const RecongnizeTeam = () => {
	return (
		<div className='about-maxims section-container' style={{ margin: '32px 0px 64px' }}>
			<div className='ncss-col-sm-6 section-block'>
				<img
					src={TeamWork}
					alt='Recognize Team Work'
					style={{
						borderRadius: '16px',
						minWidth: '380px',
						height: 'auto',
					}}
				/>
			</div>
			<div className='ncss-col-sm-6 section-block' style={{ maxWidth: '610px', minWidth: '380px' }}>
				<h1 className='section-title'>Let's Recognize Our Team</h1>
				<p className='section-p'>
					Recognize your teammates for their hard work, innovative spirit and embodiment of the Nike Maxims! The Nike High
					Five program empowers you to acknowledge good work when you see it!
				</p>
			</div>
		</div>
	)
}

export default RecongnizeTeam



// WEBPACK FOOTER //
// ./src/containers/AboutPage/Maxims/RecognizeTeam.js